<div class="banner p-3" data-cy="promo-available-banner" *ngIf="bannerDetails.visible">
  <div class="flex-grow-1 text-center">
    <img class="logo" src="/assets/images/prime-logo-black.svg" alt="Amazon Prime" />
    <span [innerHTML]="bannerDetails.content"></span>
  </div>
</div>
